<form class="mt-3" role="form" novalidate #form="ngForm" method="post" (ngSubmit)="updateUsername()">

    <div class="modal-custom">

      <div class="modal-header">
        <h4 class="modal-title"><span class="ml-2">Edit Username</span></h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
      </div>
      <!-- Modal Header End -->

      <div class="modal-body">
        <!-- Form Start -->
        <div class="form-group">

          <div class="row mt-3 ml-3">
            <label for="newUsername"><b>New Username</b></label>
          </div>

          <div class="row mt-1">
            <div class="col-md-6 ml-3" style="padding-right: 1px;">
              <div class="input-required">
                <input id="newUsername" maxlength="50" [(ngModel)]="newUsername" name="newUsername" type="text" class="form-control" reUsernameValidator required>
              </div>
            </div>
            <div style="padding-left:0px;" class="col-md-5">
              <div>
                <div class="input-group-append" *ngIf="domainOptions?.length > 0">
                  <span *ngIf="domainOptions?.length > 1">
                    <select2 [(ngModel)]="selectedDomain"
                             class="d-inline-block"
                             [settings]="{width:'100%', placeholder: 'Not Selected'}"
                             name="selectedDomain"
                             [options]="domainOptions"></select2>
                  </span>
                  <span *ngIf="domainOptions?.length==1" class="input-group-text btn-cancel" style="height:35px" id="basic-addon1">&#64;{{selectedDomain}}</span>
                </div>
                <div class="input-group-append" *ngIf="domainOptions?.length === 0">
                  <input id="noDomainText" class="form-control" style="padding-left: 1.2rem !important;" maxlength="50" type="text" placeholder="No valid domain found" [disabled]="domainOptions?.length === 0">
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-1 ml-4">
            <span *ngIf="form.controls['newUsername']?.hasError('required') && form.controls['newUsername']?.touched" class="text-danger">Please enter new username.</span>
            <small *ngIf="form.controls['newUsername']?.hasError('format') && form.controls['newUsername']?.touched" class="text-danger">
              Please enter new username without the domain, the domain has been pre populated.
            </small>
            <span *ngIf="domainOptions?.length==0" class="text-danger">No valid domain was found.</span>
          </div>

        </div>
        <!-- Form End -->

        <div class="modal-footer mt-4">
          <button type="submit" class="btn btn-primary" data-dismiss="modal" [disabled]="!form.valid">Save</button>
          <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
        </div>

      </div>
      <!-- Modal Body End -->
    </div>
    <!-- Modal Custom End -->
  </form>
